import React, { useCallback } from "react";
import { PlayCircleOutlined } from "@ant-design/icons";
import "./HistoryResults.css";
import trans from "../../../utils";

const HistoryResults = React.memo(
  ({ segments, selectedSegment, setSelectedSegment, isLoading }) => {
    const handleSegmentClick = useCallback(
      (segment) => {
        setSelectedSegment(segment);
      },
      [setSelectedSegment],
    );

    if (isLoading) {
      return (
        <div className="history-results-section">
          <h3 className="section-title">{trans("History Results")}</h3>
          <div className="empty-segments">
            <div className="empty-text">{trans("Loading segments...")}</div>
          </div>
        </div>
      );
    }

    if (!segments || segments.length === 0) {
      return (
        <div className="history-results-section">
          <h3 className="section-title">
            {trans("History Results")} (0 {trans("segments")})
          </h3>
          <div className="empty-segments">
            <div className="empty-text">
              {trans("No history segments found")}
            </div>
            <div className="empty-subtext">
              {trans("Try selecting a different date range")}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="history-results-section">
        <h3 className="section-title">
          {trans("History Results")} ({segments.length} {trans("segments")})
        </h3>
        <div className="segments-list">
          {segments.map((segment) => (
            <div
              key={segment.id}
              className={`segment-item ${selectedSegment?.id === segment.id ? "selected" : ""}`}
              onClick={() => handleSegmentClick(segment)}
            >
              <div className="segment-info">
                <div className="segment-time">
                  {segment.startTime} - {segment.endTime}
                </div>
                <div className="segment-duration">
                  {trans("Duration")}: {segment.duration}
                </div>
              </div>
              <div className="segment-play-icon">
                <PlayCircleOutlined />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  },
);

export default HistoryResults;
